import { useEffect, useRef, useState } from "react";
import "../portfolio.css";

const projects = [
    {
    title: "Modern Floating Sink",
    tag: "Family Home",
    location: "Chicago, Illinois",
    description: "Modern bathroom featuring a floating wooden vanity, gray marble countertop, matte black faucet, and a large circular mirror.",
    sqft: "",
    year: "2024",
    image: "./images/bathroom.jpg",
    },
    {
    title: "Walk In Shower",
    tag: "Family Home",
    location: "Naperville, Illinois",
    description: "Modern bathroom featuring a frameless glass walk-in shower with vertical beige tile, recessed niche, matte black rain shower head, and a modern dual-flush white toilet next to it..",
    sqft: "",
    year: "2024",
    image: "./images/shower.jpg",
    },
    {
    title: "Modern Kitchen Layout",
    tag: "Family Home",
    location: "Aurora, Illinois",
    description: "Remodeled modern kitchen with white shaker cabinets, light gray veined quartz countertops, horizontal glass mosaic backsplash, under-cabinet lighting, and stainless steel appliances over light wood floors.",
    sqft: "",
    year: "2023",
    image: "./images/kitchen.jpg",
    }
];

export default function Portfolio() {
    const [selectedProject, setSelectedProject] = useState(null);
    const cardsRef = useRef([]);

    useEffect(() => {
    const observer = new IntersectionObserver(
        entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
            entry.target.classList.add("show");
            }
        });
        },
        { threshold: 0.15 }
    );

    cardsRef.current.forEach(el => el && observer.observe(el));
    return () => observer.disconnect();
    }, []);

    return (
    <section className="portfolio-section">
        <div className="portfolio-header fade-up">
        <h2>Our Portfolio</h2>
        <p>Explore our collection of beautifully crafted custom homes</p>
        </div>

        <div className="portfolio-grid">
        {projects.map((item, i) => (
            <div
            className="portfolio-card fade-up"
            key={i}
            ref={el => (cardsRef.current[i] = el)}
            onClick={() => setSelectedProject(item)} // Open Modal
            style={{ cursor: 'pointer' }}
            >
            <div className="portfolio-image">
                <img src={item.image} alt={item.title} />
                {item.location && <span className="location-badge">📍 {item.location}</span>}
            </div>

            <div className="portfolio-content">
                <div className="card-header">
                <h3>{item.title}</h3>
                <span className="tag">{item.tag}</span>
                </div>
                <p>{item.description}</p>
                <div className="card-footer">
                <span>🏠 {item.sqft}</span>
                <span>📅 {item.year}</span>
                </div>
            </div>
            </div>
        ))}
        </div>

      {/* MODAL OVERLAY */}
        {selectedProject && (
        <div className="modal-overlay" onClick={() => setSelectedProject(null)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal" onClick={() => setSelectedProject(null)}>✕</button>
            
            <h2 className="modal-project-title">{selectedProject.title}</h2>

            <div className="modal-main-image">
                <img src={selectedProject.image} alt={selectedProject.title} />
            </div>

            <div className="modal-info-grid">
                <div className="info-box">
                <label>Location</label>
                <strong>{selectedProject.location}</strong>
                </div>
                <div className="info-box">
                <label>Category</label>
                <strong>{selectedProject.tag}</strong>
                </div>
                <div className="info-box">
                <label>Size</label>
                <strong>{selectedProject.sqft}</strong>
                </div>
                <div className="info-box">
                <label>Completed</label>
                <strong>{selectedProject.year}</strong>
                </div>
            </div>

            <div className="modal-description">
                <h3>Project Description</h3>
                <p>{selectedProject.description}</p>
            </div>
            </div>
        </div>
        )}
    </section>
    );
}